import React from 'react';
import PropTypes from 'prop-types';
import {
  Platform,
  View,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  ActivityIndicator,
} from 'react-native';
import { Button } from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { FlatGrid } from 'react-native-super-grid';

import AORTypes from '../../types';
import { AppSyncClientAudit } from '../../backends/AppSyncClientAudit';
import GetPendingReviews from '../../q/audit/GetPendingReviews';
import ReviewApprove from '../../q/audit/ReviewApprove';
import ReviewDecline from '../../q/audit/ReviewDecline';
import ReviewBadge from '../../components/apps/ReviewBadge';
import styles from '../../styles';

class PendingReviews extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PendingReviews';

    this.handleDecline = this.handleDecline.bind(this);
    this.handleApprove = this.handleApprove.bind(this);
  }

  handleApprove(uuids) {
    const { onApprove } = this.props;

    onApprove(uuids)
      .then((result) => {
        console.log('onApprove() succeeded');
        console.log(result);
      })
      .catch((result) => {
        console.log('onApprove() failed');
        console.log(result);
      });
  }

  handleDecline(uuids) {
    const { onDecline } = this.props;

    onDecline(uuids)
      .then((result) => {
        console.log('onDecline() succeeded');
        console.log(result);
      })
      .catch((result) => {
        console.log('onDecline() failed');
        console.log(result);
      });
  }

  render() {
    const {
      reviews,
      userData,
    } = this.props;

    if (!userData) {
      return (
        <View
          style={{
            backgroundColor: 'white',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      );
    }

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          <KeyboardAvoidingView
            style={[styles.form.container, {
              backgroundColor: 'white',
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            <View style={{
              flex: 1,
              flexDirection: 'column',
              width: '100%',
              alignItems: 'center',
            }}
            >
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 60,
                }}
              >
                {/* Choose the language here */}
                {/* <Text></Text> */}
              </View>
              {reviews.length < 1 ? (
                <View
                  style={{
                    flex: 1,
                    width: '100%',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Text>
                    No reviews queued for review.
                  </Text>
                </View>
              ) : (
                <ScrollView
                  style={{
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <FlatGrid
                    itemDimension={410} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
                    data={reviews}
                    renderItem={
                      ({ item }) => (
                        <View
                          style={{
                            flexDirection: 'row',
                          }}
                        >
                          <ReviewBadge data={item} />
                          <View
                            style={{
                              flexDirection: 'column',
                            }}
                          >
                            <Button
                              title="Decline"
                              containerStyle={styles.button.secondaryContainer}
                              buttonStyle={styles.button.secondary}
                              disabledStyle={styles.button.secondaryDisabled}
                              titleStyle={styles.button.secondaryTitle}
                              disabledTitleStyle={styles.button.secondaryTitleDisabled}
                              onPress={() => this.handleDecline(item.uuids)}
                            />
                            <Button
                              title="Approve"
                              containerStyle={styles.button.primaryContainer}
                              buttonStyle={styles.button.primary}
                              disabledStyle={styles.button.primaryDisabled}
                              titleStyle={styles.button.primaryTitle}
                              disabledTitleStyle={styles.button.primaryTitleDisabled}
                              onPress={() => this.handleApprove(item.uuids)}
                            />
                          </View>
                        </View>
                      )
                    }
                  />
                </ScrollView>
              )}
            </View>
          </KeyboardAvoidingView>
        </View>
      </View>
    );
  }
}

PendingReviews.defaultProps = {
  reviews: [],
  userData: null,
};

PendingReviews.propTypes = {
  reviews: PropTypes.arrayOf(AORTypes.Review),
  userData: AORTypes.User,
  onApprove: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
};

export default compose(
  graphql(GetPendingReviews, {
    props: (props) => {
      console.log('graphql returned: GetPendingReviews: ');
      console.log(props.data);

      if (!props.data.getPendingReviews) {
        return {
          reviews: [],
        };
      }
      return {
        reviews: props.data.getPendingReviews.items,
      };
    },
    options: (props) => ({
      variables: {
        lang: '*',
      },
      client: AppSyncClientAudit(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAudit(props.user),
  }),
  graphql(ReviewApprove, {
    props: (props) => ({
      onApprove: (uuids) => props.mutate({
        variables: {
          uuids,
        },
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetPendingReviews,
        variables: {
          lang: '*',
        },
        client: AppSyncClientAudit(props.user),
      }],
      client: AppSyncClientAudit(props.user),
    }),
  }),
  graphql(ReviewDecline, {
    props: (props) => ({
      onDecline: (uuids) => props.mutate({
        variables: {
          uuids,
        },
      }),
    }),
    options: (props) => ({
      refetchQueries: [{
        query: GetPendingReviews,
        variables: {
          lang: '*',
        },
        client: AppSyncClientAudit(props.user),
      }],
      client: AppSyncClientAudit(props.user),
    }),
  })
)(PendingReviews);
